import { redirect } from 'react-router-dom';
import { loadSavedSearches } from 'ha/modules/SavedSearches/actions/loadSavedSearches';
import { load as loadFeaturedCities } from 'ha/modules/FeaturedCities/actions';
import { getUserId } from 'ha/modules/AuthLogic/selectors';
import { loadHermesData } from 'ha/modules/Hermes';
import { PageLoaderFunction, InjectAsyncReducer } from 'ha/types/routing';

import { getShowNewTaxonomy } from 'ha/modules/ULE/selectors';
import { STATE_NAME, TopCitiesNameList } from './constants';
import { reducer } from './reducer';
import { getCities, getCounts } from './actions';
import { getCities as getCitiesSelector } from './selectors';

export { HomePage as default } from './containers/HomePage';

export const loader: PageLoaderFunction = async ({
  context: { store, intl },
  request,
}) => {
  const { dispatch, getState } = store;
  const { lang, urlResolver } = intl;
  const url = new URL(request.url);

  const state = getState();
  const userId = getUserId(state);

  const showNewTaxonomy = getShowNewTaxonomy(state);

  if (showNewTaxonomy && !url.searchParams.get('noredirect')) {
    // eslint-disable-next-line @typescript-eslint/no-throw-literal
    throw redirect(urlResolver.getDashboardUrl());
  }

  await Promise.all([
    userId
      ? dispatch(loadSavedSearches(userId, { language: lang }))
      : Promise.resolve(),
    dispatch(loadFeaturedCities()),
    dispatch(getCities(TopCitiesNameList, lang)).then(() => {
      const cities = getCitiesSelector(getState());

      return dispatch(getCounts(cities));
    }),
    dispatch(loadHermesData(urlResolver.getHomePageDataUrl(lang))),
  ]);
};

export const injectAsyncReducer: InjectAsyncReducer = store => {
  store.injectAsyncReducer(STATE_NAME, reducer);
};
